const transactionTypes = {
  WITHDRAW: 'withdraw',
  DEPOSIT: 'deposit',
  TRANSFER: 'transfer',
};

export default transactionTypes;
